import { RenderFederatedModule } from '@benefits/components';
import { Fragment } from 'react';

import { Container } from './Zendesk.styles';

const Zendesk: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <RenderFederatedModule
        component="salesforce-bot"
        errorBoundary={() => <Fragment />}
        loadingComponent={() => <Fragment />}
        remote="dashboard"
      />
    </Container>
  );
};

export default Zendesk;
